<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-button class="btn-round"
                  :variant="(isOpenFormAddNew ? 'danger' : 'primary')"
                  @click="showAndHideForm">
          {{ (isOpenFormAddNew ? "close" : "+ Add Map") }}
        </b-button>
        <b-button class="btn-round"
                  :variant="(isOpenFormImagePage ? 'danger' : 'primary')"
                  @click="showAndHideFormImagePage">
          {{ (isOpenFormImagePage ? "close" : "+ Page Image") }}
        </b-button>
        <b-button class="btn-round"
                  :variant="(isOpenFormImageTabletPage ? 'danger' : 'primary')"
                  @click="showAndHideFormImagePageTablet">
          {{ (isOpenFormImageTabletPage ? "close" : "+ Page Image Tablet") }}
        </b-button>
        <b-button class="btn-round"
                  :variant="(isOpenFormImageMobilePage ? 'danger' : 'primary')"
                  @click="showAndHideFormImagePageMobile">
          {{ (isOpenFormImageMobilePage ? "close" : "+ Page Image Mobile") }}
        </b-button>
      </template>
    </navbar>
    <!--END Navbar-->

    <b-card title="Upload Image Page Map" v-if="isOpenFormImagePage">
      <template>
        <b-form-group
            class="required"
            label="image">
          <template v-if="previewUrlImagePage !== null">
            <b-img width="120" :src="previewUrlImagePage" alt=""></b-img>
          </template>

          <b-form-file v-model="formPageImage.file" @change="onSelectFilePageMap"></b-form-file>
        </b-form-group>

        <br>

        <b-button @click="storeImagePage" variant="success">save</b-button>


      </template>

    </b-card>
    <!--END Form Image Page-->

    <b-card title="Upload Image Page Map (Tablet version)" v-if="isOpenFormImageTabletPage">
      <template>
        <b-form-group
            class="required"
            label="image">
          <template v-if="previewUrlImageTabletPage !== null">
            <b-img width="120" :src="previewUrlImageTabletPage" alt=""></b-img>
          </template>

          <b-form-file v-model="formPageImage.fileTablet" @change="onSelectFilePageMapTabletVersion"></b-form-file>
        </b-form-group>

        <br>

        <b-button @click="storeImagePage" variant="success">save</b-button>


      </template>

    </b-card>
    <!--END Form Image Page (Tablet version)-->

    <b-card title="Upload Image Page Map (Mobile version)" v-if="isOpenFormImageMobilePage">
      <template>
        <b-form-group
            class="required"
            label="image">
          <template v-if="previewUrlImageMobilePage !== null">
            <b-img width="120" :src="previewUrlImageMobilePage" alt=""></b-img>
          </template>

          <b-form-file v-model="formPageImage.fileMobile" @change="onSelectFilePageMapMobileVersion"></b-form-file>
        </b-form-group>

        <br>

        <b-button @click="storeImagePage" variant="success">save</b-button>


      </template>

    </b-card>
    <!--END Form Image Page (Mobile version)-->

    <b-card title="Add" v-if="isOpenFormAddNew">
      <template>
        <b-form-group label="select country">
          <b-form-select
              v-model="form.country_id"
              :options="countries"
              class="mb-3"
              value-field="city_id"
              text-field="city_name"
          ></b-form-select>

        </b-form-group>
        <b-form-group
            class="required"
            label="image">
          <template v-if="previewUrl !== null">
            <b-img width="120" :src="previewUrl" alt=""></b-img>
          </template>

          <b-form-file v-model="form.image" @change="onSelectFile"></b-form-file>
        </b-form-group>
        <b-form-group
            class="required"
            label="title">
          <b-input v-model="form.title"></b-input>
        </b-form-group>
        <b-form-group
            class="required"
            label="link">
          <b-input v-model="form.link"></b-input>
        </b-form-group>

        <b-form-group
            class="required"
            label="description">
          <tinymce id="d1" v-model="form.description"></tinymce>
        </b-form-group>

        <b-form-group
            label="Options">
          <b-form-checkbox v-model="form.is_hide">is Hide?</b-form-checkbox>
        </b-form-group>

        <br>
        <br>


        <template v-if="editedItemId > 0">
          <b-button @click="updateGift" variant="success">save</b-button>
        </template>

        <template v-else>
          <b-button @click="storeGift" variant="success">save</b-button>
        </template>

      </template>

    </b-card>
    <!--END Form-->

    <h2>Maps: {{ items.length }}</h2>

    <b-form-input v-model="searchInput" placeholder="search Automat ..."></b-form-input>

    <b-form-group label="select country">
      <b-form-select
          v-model="filter.countryId"
          :options="countries"
          class="mb-3"
          @change="onSelectFilter"
          value-field="city_id"
          text-field="city_name"
      ></b-form-select>

    </b-form-group>
    <a
        v-if="filter.countryId > 0"
        class="text-danger"
        @click.prevent="deleteFilter"
        href="#">show all</a>

    <template v-if="items.length > 0">

      <draggable v-model="items" group="items"
                 @update="updateOrder"
                 @start="drag=true"
                 handle=".handle"
                 @end="drag=false">

        <b-card v-for="(item,index) in getMapsSearch"
                :class="{'bg-dark':item.is_hide === 'yes'}"
                :key="index">
          <b-media>
            <template #aside>
              <b-img :src="item.image" width="64" alt="placeholder"></b-img>
            </template>

            <h2 class="font-weight-bold">{{ item.country }}</h2>
            <h3>{{ item.title }}</h3>
            <div v-html="item.description"></div>
            <p class="mb-0">
                        <span class="ml-4 text-primary">
                            <a @click.prevent="editItem(item)" href="#">
                                <span class="material-icons">edit</span>
                            </a>
                            <a class="text-danger ml-3"
                               @click.prevent="deleteGift(item.id)"
                               href="#">
                                <span class="material-icons">delete</span>
                            </a>
                            <a class="text-primary ml-3"
                               target="_blank"
                               :href="item.link">
                                <span>link</span>
                            </a>
                        </span>
            </p>
            <p class="text-right font-weight-bold" style="font-size: 24px">
                            <span v-if="filter.countryId > 0" class="mr-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
              <span>{{ ++index }}</span>
            </p>
          </b-media>
        </b-card>
      </draggable>


    </template>
    <!--gifts-->

  </div>
</template>

<script>

import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notificaion from '../../Services/Notification/Nottification'
import draggable from 'vuedraggable'


export default {
  name: "Index",
  components: {
    Navbar,
    draggable
  },
  data() {
    return {
      mapsCount: 0,
      searchInput: null,
      isOpenFormAddNew: false,
      isOpenFormImagePage: false,
      isOpenFormImageTabletPage: false,
      isOpenFormImageMobilePage: false,
      dictionary: null,
      previewUrl: null,
      previewUrlImagePage: null,
      previewUrlImageTabletPage: null,
      previewUrlImageMobilePage: null,
      products: [],
      items: [],
      countries: [],
      itemsFree: [],
      form: {
        country_id: null,
        description: null,
        link: null,
        image: null,
        title: null,
        is_hide: false,
      },
      formPageImage: {
        file: null,
        fileTablet: null,
        fileMobile: null,
        fileName: 'mapPageImage',
        fileNameTablet: 'mapPageImageTablet',
        fileNameMobile: 'mapPageImageMobile',
      },
      filter: {
        countryId: null,
      },
      editedItemId: null,
    }
  },
  methods: {
    deleteFilter() {
      this.filter.countryId = null;
      this.getItems();
    },
    updateOrder() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'map/order/items/process', {
        items: this.items
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.getItems();
              Notificaion.success(response.data.message)
            } else {
              Notificaion.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    onSelectFile(event) {
      this.previewUrl = URL.createObjectURL(event.target.files[0]);
    },
    onSelectFilePageMap(event) {
      this.previewUrlImagePage = URL.createObjectURL(event.target.files[0]);
    },
    onSelectFilePageMapTabletVersion(event) {
      this.previewUrlImageTabletPage = URL.createObjectURL(event.target.files[0]);
    },
    onSelectFilePageMapMobileVersion(event) {
      this.previewUrlImageMobilePage = URL.createObjectURL(event.target.files[0]);
    },
    showAndHideForm() {
      this.isOpenFormAddNew = !this.isOpenFormAddNew;

      if (!this.isOpenFormAddNew) {
        this.editedItemId = 0;
      }
    },
    showAndHideFormImagePage() {
      this.isOpenFormImagePage = !this.isOpenFormImagePage;
      this.isOpenFormImageTabletPage=false;
      this.isOpenFormImageMobilePage=false;
      if (this.isOpenFormImagePage) {
        this.getImagePage(this.formPageImage.fileName);
      }
    },
    showAndHideFormImagePageTablet() {
      this.isOpenFormImageTabletPage = !this.isOpenFormImageTabletPage;
      this.isOpenFormImagePage=false;
      this.isOpenFormImageMobilePage=false;
      if (this.isOpenFormImageTabletPage) {
        this.getImagePage(this.formPageImage.fileNameTablet);
      }
    },
    showAndHideFormImagePageMobile() {
      this.isOpenFormImageMobilePage = !this.isOpenFormImageMobilePage;
      this.isOpenFormImagePage=false;
      this.isOpenFormImageTabletPage=false;
      if (this.isOpenFormImageMobilePage) {
        this.getImagePage(this.formPageImage.fileNameMobile);
      }
    },
    editItem(myItem) {
      window.scrollTo(0, 0);
      this.isOpenFormAddNew = true;
      this.editedItemId = myItem.id;
      setTimeout(() => {
        this.form.country_id = myItem.country_id;
        this.form.description = myItem.description;
        this.form.link = myItem.link;
        this.previewUrl = myItem.image;
        this.form.title = myItem.title;
        this.form.is_hide = (myItem.is_hide === 'yes');
      }, 1000);
    },
    storeGift() {

      if (this.form.country_id === null) {
        Notificaion.error("please select country");
        return;
      }

      if (this.form.image === null) {
        Notificaion.error("please select image");
        return;
      }

      if (this.form.title === null) {
        Notificaion.error("please enter title");
        return;
      }

      if (this.form.link === null) {
        Notificaion.error("please enter link");
        return;
      }

      if (this.form.description === null) {
        Notificaion.error("please enter description");
        return;
      }


      this.$Progress.start();

      let fd = new FormData();
      fd.append("country_id", this.form.country_id);
      fd.append("description", this.form.description);
      fd.append("title", this.form.title);
      fd.append("link", this.form.link);
      fd.append("image", this.form.image);
      fd.append("is_hide", this.form.is_hide);

      Http.post(Http.apiurlV2() + 'map/store', fd)
          .then(response => {
            if (response.data.status_code === Http.created()) {
              this.$Progress.finish();
              this.editedItemId = 0;
              this.form.description = null;
              this.form.link = null;
              this.form.image = null;
              this.form.title = null;
              this.form.is_hide = false;
              this.form.country_id = null;
              this.filter.countryId = null;
              this.previewUrl = null;
              this.isOpenFormAddNew = false;
              this.getItems();
              Notificaion.success(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    storeImagePage() {

      if (this.isOpenFormImagePage && this.formPageImage.file === null) {
        Notificaion.error("please select image");
        return;
      }

      if (this.isOpenFormImageTabletPage && this.formPageImage.fileTablet === null) {
        Notificaion.error("please select image");
        return;
      }

      if (this.isOpenFormImageMobilePage && this.formPageImage.fileMobile === null) {
        Notificaion.error("please select image");
        return;
      }

      this.$Progress.start();

      let fd = new FormData();
      if (this.isOpenFormImagePage){
        fd.append("file", this.formPageImage.file);
        fd.append("upload_name", this.formPageImage.fileName);
      }

      if (this.isOpenFormImageTabletPage){
        fd.append("file", this.formPageImage.fileTablet);
        fd.append("upload_name", this.formPageImage.fileNameTablet);
      }

      if (this.isOpenFormImageMobilePage){
        fd.append("file", this.formPageImage.fileMobile);
        fd.append("upload_name", this.formPageImage.fileNameMobile);
      }


      Http.post(Http.apiurlV2() + 'setting/file/store', fd)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.formPageImage.file = null;
              this.formPageImage.fileTablet = null;
              this.formPageImage.fileMobile = null;
              this.previewUrlImagePage = null;
              this.previewUrlImageTabletPage = null;
              this.previewUrlImageMobilePage = null;
              if (this.isOpenFormImagePage){
                this.getImagePage(this.formPageImage.fileName)
              }
              if (this.isOpenFormImageTabletPage){
                this.getImagePage(this.formPageImage.fileNameTablet)
              }
              if (this.isOpenFormImageMobilePage){
                this.getImagePage(this.formPageImage.fileNameMobile)
              }

              Notificaion.success(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    onSelectFilter() {
      this.items = [];
      this.getItems();
    },
    getItems() {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'map/index', this.filter)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.items = response.data.data.maps;
              this.countries = response.data.data.countries;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    getImagePage(imageName) {
      this.$Progress.start();
      Http.get(Http.apiurlV2() + 'setting/file/show/' + imageName)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              if (this.isOpenFormImagePage){
                this.previewUrlImagePage = response.data.data.file;
              }
              if (this.isOpenFormImageTabletPage){ // tablet page
                this.previewUrlImageTabletPage = response.data.data.file;
              }
              if (this.isOpenFormImageMobilePage){ // mobile page
                this.previewUrlImageMobilePage = response.data.data.file;
              }
              this.$Progress.finish();
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    updateGift() {

      if (this.form.title === null || this.form.title.length === 0) {
        Notificaion.error("please enter title");
        return;
      }

      if (this.form.link === null || this.form.link.length === 0) {
        Notificaion.error("please enter link");
        return;
      }

      if (this.form.description === null || this.form.description.length === 0) {
        Notificaion.error("please enter description");
        return;
      }

      this.$Progress.start();

      let fd = new FormData();
      fd.append("country_id", this.form.country_id);
      fd.append("description", this.form.description);
      fd.append("title", this.form.title);
      fd.append("link", this.form.link);
      fd.append("is_hide", this.form.is_hide);
      if (this.form.image !== null) {
        fd.append("image", this.form.image);
      }

      Http.post(Http.apiurlV2() + 'map/update/' + this.editedItemId, fd)
          .then(response => {
            if (response.data.status_code === Http.ok()) {
              this.$Progress.finish();
              this.getItems();
              this.editedItemId = 0;
              this.form.country_id = null;
              this.form.description = null;
              this.form.link = null;
              this.form.title = null;
              this.form.image = null;
              this.form.is_hide = false;
              this.form.previewUrl = null;
              this.isOpenFormAddNew = false;
              Notificaion.success(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    deleteGift(id) {
      if (confirm("Are you sure delete this item ?")) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'map/delete/' + id)
            .then(response => {
              if (response.data.status_code === Http.ok()) {
                this.$Progress.finish();
                this.getItems();
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
  },
  computed: {
    getMapsSearch() {
      if (this.searchInput === null) {
        return this.items;
      }

      return this.items.filter(item => {
        return item.title.toLowerCase().match(this.searchInput.toLowerCase())
      })
    },
  },
  created() {
    this.getItems();
  }

}
</script>

<style scoped>

</style>